// @ts-check

/** Toggle desktop nav */
const desktopNav = function () {
  /**
   * @type {HTMLElement | null}
   */
  const nav = document.querySelector(".header__desktop-nav");

  /**
   * @type {NodeListOf<Element> | undefined}
   */
  const navLinks = nav?.querySelectorAll("[aria-controls]");

  /**
   * @type {NodeListOf<Element>}
   */
  const childSections = document.querySelectorAll(".mega-nav__section");

  /**
   * @var {Record<string, string>}
   * A list of classes used as CSS styling hooks
   */
  const classes = {
    isActive: "is-mega-nav",
  };

  /**
   * Toggle specific child-level of desktop nav
   * @param {Event} event
   *
   * @return {void}
   */
  const toggleChild = (event) => {
    event.preventDefault();

    const button = event.currentTarget;
    const activeChild = document.querySelector(
      `#${button?.getAttribute("aria-controls")}`
    );
    const isActive =
      button?.getAttribute("aria-expanded").toString() === "true";

    let i = 0;

    if (isActive) {
      activeChild?.setAttribute("hidden", "true");
      button.setAttribute("aria-expanded", "false");
      document.documentElement.classList.remove(classes.isActive);
    } else {
      document.documentElement.classList.add(classes.isActive);
      // open specific child
      activeChild?.removeAttribute("hidden");
      button?.setAttribute("aria-expanded", "true");

      // hide other items others and set other buttons to not expanded
      if (navLinks) {
        for (i = 0; i < navLinks.length; i++) {
          if (navLinks[i] !== button) {
            navLinks[i].setAttribute("aria-expanded", "false");
          }
        }
      }

      for (i = 0; i < childSections.length; i++) {
        if (childSections[i] !== activeChild) {
          childSections[i].setAttribute("hidden", "true");
        }
      }
    }
  };

  /**
   * Close any active mega-nav (desktop nav).
   * Used if the user clicks Esc or clicks away
   *
   * @return {void}
   */
  const closeAllDesktopChildNav = () => {
    document.documentElement.classList.remove(classes.isActive);

    // hide other items others and set other buttons to not expanded
    if (navLinks) {
      for (let i = 0; i < navLinks.length; i++) {
        navLinks[i].setAttribute("aria-expanded", "false");
      }
    }

    for (let i = 0; i < childSections.length; i++) {
      childSections[i].setAttribute("hidden", "true");
    }
  };

  /**
   * Handle keydown events, only used to handle Esc key which showuld close all open menus
   * @param {KeyboardEvent} event
   *
   * @return {void}
   */
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      // if esc key was not pressed in combination with ctrl or alt or shift
      const isNotCombinedKey = !(
        event.ctrlKey ||
        event.altKey ||
        event.shiftKey
      );
      if (isNotCombinedKey) {
        closeAllDesktopChildNav();
      }
    }
  };

  /**
   * Detects a click outside the mega-nav (when it's active)
   * @param {Event} event
   *
   * @return {void}
   */
  const outsideClickListener = (event) => {
    const list = event.currentTarget.querySelector("ul");
    const isClickInside = list.contains(event.target);

    if (event.currentTarget.hasAttribute("hidden")) {
      return;
    }

    if (!isClickInside) {
      closeAllDesktopChildNav();
    }
  };

  /**
   * Adds event listeners (and removes them too)
   *
   * @return {void}
   */
  const addEventListeners = () => {
    // Allow user to toggle the child menus
    if (navLinks) {
      for (let i = 0; i < navLinks.length; i++) {
        navLinks[i].removeEventListener("click", toggleChild);
        navLinks[i].addEventListener("click", toggleChild);
      }
    }

    // Let user press Esc to close menu
    document.removeEventListener("keydown", handleKeyDown);
    document.addEventListener("keydown", handleKeyDown);

    // Let click outside to close menu
    for (let i = 0; i < childSections.length; i++) {
      childSections[i].removeEventListener("click", outsideClickListener);
      childSections[i].addEventListener("click", outsideClickListener);
    }
  };

  /**
   * Scripts/tasks that run when object is first created
   *
   * @returns {void}
   */
  const init = () => {
    addEventListeners();
  };

  return {
    init,
  };
};

desktopNav().init();
